import { Typography, styled, Avatar } from '@ori-ui/mui';
import { useGetCustomerProfileImage } from '@ori/global-api-client-react';
import useTestId from '@ori/testid-generator';
import type { FC } from 'react';

import { Localization } from '../../../Localization';
import { defaultTranslations } from '../../../constants/defaultTranslations_simplified-registration-BrandPartner';
import { useConfiguration } from '../../../contexts';
import { TranslationKey } from '../../../models';
import { usePublicSponsorImage } from '../../../models/api';
import { stringAvatar } from '../../../utils';

const RootContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  maxWidth: '500px',
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(6),
}));

const StyledAvatar = styled(Avatar)(({ theme }) => ({
  width: '70px',
  height: '70px',
  color: theme.palette.text.primary,
  textDecoration: 'none',
}));

const StyledInfo = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  marginLeft: theme.spacing(3),
}));

export const PublicSponsorBox: FC<{ displayOrder?: number | null }> = ({ displayOrder }) => {
  const { referral } = useConfiguration();
  const { data: sponsorDocument } = useGetCustomerProfileImage(referral?.CustomerId ?? 0);
  const sponsorImage = usePublicSponsorImage(referral?.CustomerId, sponsorDocument?.documentId);

  const { getTestIdProps } = useTestId();

  return (
    <RootContainer
      {...getTestIdProps('sponsorBox-prestep')}
      sx={{ order: displayOrder }}
    >
      {referral?.FullName ? (
        <StyledAvatar
          {...stringAvatar(referral.FullName)}
          src={sponsorImage}
        />
      ) : null}
      <StyledInfo>
        <Typography
          variant="caption"
          color="textPrimary"
        >
          <Localization
            id={TranslationKey.Prestep_ReferralTitle}
            defaultMessage={defaultTranslations.Prestep_ReferralTitle}
          />
        </Typography>

        <Typography
          variant="subtitle1"
          color="textPrimary"
          align="left"
          sx={{ fontWeight: 'bold' }}
        >
          {referral?.FullName}
        </Typography>
      </StyledInfo>
    </RootContainer>
  );
};
